var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tbody",
    _vm._l(_vm.currentContractors, function (contractor) {
      return _c("tr", { key: contractor.id, staticClass: "table-row" }, [
        _c("td", [_vm._v(_vm._s(contractor.userAccount))]),
        _vm._v(" "),
        _c("td", [
          _vm._v(
            _vm._s(
              _vm.displayI18nFullName(contractor.firstName, contractor.lastName)
            )
          ),
        ]),
        _vm._v(" "),
        _c("td", [_vm._v(_vm._s(contractor.contractorType))]),
        _vm._v(" "),
        _c("td", [_vm._v(_vm._s(contractor.companyName))]),
        _vm._v(" "),
        _c("td", [_vm._v(_vm._s(contractor.officeTel))]),
        _vm._v(" "),
        _c("td", [_vm._v(_vm._s(contractor.mobile))]),
        _vm._v(" "),
        _c("td", { staticClass: "last-login" }, [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.formatDate(
                  contractor.user ? contractor.user.lastLoginAt : ""
                )
              ) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c("td", { staticClass: "last-invite" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.formatDate(contractor.lastInviteDateTime)) +
              "\n    "
          ),
        ]),
        _vm._v(" "),
        _c(
          "td",
          [
            contractor.userAccount && _vm.canInvite
              ? _c("HKLButton", {
                  staticClass: "invite-btn no-min-width no-min-height",
                  attrs: { color: "darkblue", action: "invite" },
                  on: {
                    click: function ($event) {
                      return _vm.invite(contractor)
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }